export const getListingImagesUrls = listing => {
  const converted = listing?.images?.map(i => i?.attributes?.variants['listing-card-4x']?.url);

  return converted;
};
